function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 6V0H10V6H16V10H10V16H6V10H0V6H6ZM12 18V12H18V6H32L35.66 10H42C44.2 10 46 11.8 46 14V38C46 40.2 44.2 42 42 42H10C7.8 42 6 40.2 6 38V18H12ZM26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36ZM19.6 26C19.6 29.54 22.46 32.4 26 32.4C29.54 32.4 32.4 29.54 32.4 26C32.4 22.46 29.54 19.6 26 19.6C22.46 19.6 19.6 22.46 19.6 26Z",
  fill: "#DEE1FF"
});

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6rem",
    height: "6rem",
    viewBox: "0 0 46 42",
    fill: "#DEE1FF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.a040912b.svg";
export { ForwardRef as ReactComponent };